import { ISignable } from "@/mixins/SignalsMixin/interfaces";
import { SignableType } from "@/services/DTOs/SignalDetail";

export interface IOrganization {
  id: number;
  name: string;
  size: number | null;
  picture: string | undefined;
  professionalHeadline: string | null;
  publicId: string;
}

export class Organization implements ISignable {
  public id: number;
  public name: string;
  public size: number | null;
  public picture: string | undefined;
  public professionalHeadline: string | null;
  public publicId: string;

  constructor(data: IOrganization) {
    this.id = data.id;
    this.name = data.name;
    this.size = data.size;
    this.picture = data.picture;
    this.professionalHeadline = data.professionalHeadline;
    this.publicId = data.publicId;
  }

  public signableId(): string | undefined {
    return this.id.toString();
  }

  public signableType(): SignableType {
    return SignableType.Organization;
  }
}
